import { useIntl } from 'react-intl';

import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import { CONTACT_DETAILS } from '@/lib/const';
import { formMessages } from '@/messages/forms';

import * as S from '../ContactUs.styles';
import { messages } from '../messages';

interface SendEmail {
  handleEmailClick: (value: string) => void;
  header: string | undefined | null;
}
export const SendEmail: React.FC<SendEmail> = ({
  handleEmailClick,
  header,
}) => {
  const { formatMessage } = useIntl();
  return (
    <S.Card>
      <SectionHeader
        colorized={false}
        data-test-id='ConfirmationViewSectionHeader'
        disableGutters
        sizeDesktop={32}
        sizeMobile={28}
        text={header ?? formatMessage(messages.sendEmail)}
        textAlign='left'
      />
      <S.Section>
        <S.Pointer>
          <Typography
            fontWeight='regular'
            onClick={() =>
              handleEmailClick(CONTACT_DETAILS.DEFAULT!.contact_email)
            }
            scale='p2'
          >
            {formatMessage(formMessages.email)}{' '}
            <S.Underline>{CONTACT_DETAILS.DEFAULT?.contact_email}</S.Underline>
          </Typography>
        </S.Pointer>
      </S.Section>
    </S.Card>
  );
};
